export default __webpack_public_path__ + "static/media/grandworld3.59e45a03.jpeg";